var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 16.97C19.32 16.27 19.58 15.46 19.58 14.58C19.58 12.09 17.57 10.08 15.08 10.08C12.59 10.08 10.58 12.09 10.58 14.58C10.58 17.07 12.59 19.08 15.07 19.08C15.95 19.08 16.77 18.82 17.46 18.38L20.58 21.5L22 20.08L18.88 16.97ZM15.08 17.08C13.7 17.08 12.58 15.96 12.58 14.58C12.58 13.2 13.7 12.08 15.08 12.08C16.46 12.08 17.58 13.2 17.58 14.58C17.58 15.96 16.46 17.08 15.08 17.08ZM14.72 8.58C13.98 8.6 13.27 8.76 12.62 9.03L12.07 8.2L8.27 14.38L5.26 10.86L1.63 16.67L0 15.5L5 7.5L8 11L12 4.5L14.72 8.58ZM17.31 9.08C16.67 8.8 15.98 8.63 15.26 8.59L20.38 0.5L22 1.68L17.31 9.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceIcon);
export default __webpack_public_path__ + "static/media/performance-icon.cb30381be6a0656d0d7120c118ea6df1.svg";
export { ForwardRef as ReactComponent };